// Mensagens a partir do "code" que a API devolve nos erros. Códigos novos que ainda não
// estão aqui caem no "message" da própria API e, por último, no texto genérico.

const MESSAGES = {
  lead_full: "Este pedido já atingiu o limite de DJs.",
  unlock_pending: "Seu Pix está sendo processado. O contato aparece assim que o pagamento confirmar.",
  lead_expired: "A data deste evento já passou. O pedido não pode mais ser liberado.",
  too_many_requests: "Muitas tentativas em pouco tempo. Aguarde um instante e tente de novo.",
  too_many_pending_unlocks:
    "Você já tem liberações aguardando pagamento. Conclua ou aguarde antes de liberar outro pedido.",
  payment_unavailable: "Pagamento indisponível no momento. Tente novamente.",
  already_premium: "Você já é Premium.",
  no_billing_account: "Não encontramos uma conta de cobrança para gerenciar.",
  lead_locked: "Libere o contato deste pedido antes de continuar.",
  premium_required: "Este recurso é exclusivo do plano Premium.",
  admin_required: "Você não tem permissão para acessar este recurso.",
};

// 403 que o interceptor já mostra ao usuário: telas não devem repetir o alerta.
const HANDLED_BY_INTERCEPTOR = ["premium_required", "lead_locked", "admin_required"];

export const isHandledGlobally = (error) => HANDLED_BY_INTERCEPTOR.includes(error?.code);

export function getApiErrorMessage(error, fallback = "Algo deu errado. Tente novamente.") {
  if (!error) return fallback;

  if (error.code === "unlock_cooldown") {
    const seconds = Number(error.retry_after);
    return seconds > 0
      ? `Aguarde ${seconds} segundo${seconds === 1 ? "" : "s"} antes de tentar de novo.`
      : MESSAGES.too_many_requests;
  }
  if (MESSAGES[error.code]) return MESSAGES[error.code];
  if (error.httpStatus === 429) return MESSAGES.too_many_requests;
  if (typeof error.message === "string" && error.message && error.httpStatus && error.httpStatus < 500) {
    return error.message;
  }
  return fallback;
}

export const formatCents = (cents) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format((cents || 0) / 100);
